// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-editor p {
  margin-bottom: 1rem;
}

.ql-editor h1 {
  margin-bottom: 1.5rem;
}

.ql-editor h2 {
  padding-top: 1.25rem;
  margin-bottom: 1rem;
}

.ql-editor h3 {
  margin-bottom: 1rem;
}

.ql-editor h4 {
  margin-bottom: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/global.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AACA;EACE,oBAAA;EACA,mBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AAAA;EACE,sBAAA;AAGF","sourcesContent":[".ql-editor p {\n  margin-bottom: 1rem;\n}\n\n.ql-editor h1 {\n  margin-bottom: 1.5rem;\n}\n.ql-editor h2 {\n  padding-top: 1.25rem;\n  margin-bottom: 1rem;\n}\n\n.ql-editor h3 {\n  margin-bottom: 1rem;\n}\n.ql-editor h4 {\n  margin-bottom: 0.75rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
